export const gluing = {
    "STANDARD": "Стандарт",
    "STANDARD_WHITE": "Стандарт белый",
    "PUR": "Пур",
    "PUR_WHITE": "Пур белый",
    "LASER":"Лазер"
}
